import { create } from 'zustand';
import { Toast, AlertType } from '../types';

interface ToastState {
  toasts: Toast[];
  addToast: (toast: Omit<Toast, 'id'> & { duration?: number }) => void;
  removeToast: (id: string) => void;
  clearToastsByType: (type: AlertType) => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  addToast: (toast) => {
    const id = Math.random().toString(36).substr(2, 9);
    const duration = toast.duration ?? (toast.type === AlertType.Institutional ? 15000 : 5000);

    set((state) => ({ toasts: [...state.toasts, { id, ...toast, duration }] }));

    setTimeout(() => {
      set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
    }, duration);
  },
  removeToast: (id) => {
    set((state) => ({ toasts: state.toasts.filter((toast) => toast.id !== id) }));
  },
  clearToastsByType: (type) => {
    set((state) => ({ toasts: state.toasts.filter((toast) => toast.type !== type) }));
  },
}));
